import {
  DEFAULT_MATCH_RESIDENT_NUMBER,
  DEFAULT_MATCH_ROOM_NUMBER,
  DEFAULT_MY_PATIENTS_ENABLED,
  DEFAULT_PATIENT_MONITORING_ENABLED,
  DEFAULT_SYNC_ALL_PATIENTS,
  DEFAULT_SYNC_CAREGIVERS,
  DEFAULT_SYNC_MINIMAL_DATA,
  DEFAULT_SYNC_PATIENTS,
} from '@/utils/defaults'

export const enum AdminSiteManagementDeviceTypes {
  Tracker = 'Vibe + Tracker',
  CommonGateway = 'Shared Gateway',
  Scale = 'Scale',
  PulseOximeter = 'Pulse Oximeter',
  Thermometer = 'Thermometer',
  Inhaler = 'Inhaler',
  BloodPressureMonitor = 'Vital Sign Machine',
  Glucometer = 'Glucometer',
  PcrMachine = 'PCR Machine',
}
export const AdminSiteManagementDeviceTypeUploadKeys = {
  [AdminSiteManagementDeviceTypes.Tracker]: 'vibe-tracker',
  [AdminSiteManagementDeviceTypes.CommonGateway]: 'common-gateway',
  [AdminSiteManagementDeviceTypes.Scale]: 'scale',
  [AdminSiteManagementDeviceTypes.PulseOximeter]: 'pulse-oximeter',
  [AdminSiteManagementDeviceTypes.Thermometer]: 'thermometer',
  [AdminSiteManagementDeviceTypes.Inhaler]: 'inhaler',
  [AdminSiteManagementDeviceTypes.BloodPressureMonitor]: 'vital-sign-machine',
  [AdminSiteManagementDeviceTypes.Glucometer]: 'glucometer',
  [AdminSiteManagementDeviceTypes.PcrMachine]: 'pcr',
}

export const enum AdminSiteManagementWizardNextButtonActionNames {
  NextWizardStage = 'goToNextWizardStage',
  // NextSelectedDevice = 'goToNextSelectedDevice',
  // Confirm = 'confirm',
}

export const enum AdminSiteManagementWizardBackButtonActionNames {
  PreviousWizardStage = 'goToPreviousWizardStage',
  PreviousSelectedDevice = 'goToPreviousSelectedDevice',
}

export type AdminSiteManagementDevice = {
  type: string | null
  deviceId: string | null
  isSelected: boolean
  deviceIndex: number | null
  quantity: number
  units: Array<AdminSiteManagementUnit> | null
}

export type AdminSiteManagementUnit = {
  serialNumber: string | null
}

export function needsSerialNumber(type) {
  switch (type) {
    case AdminSiteManagementDeviceTypes.CommonGateway:
      return true
    case AdminSiteManagementDeviceTypes.BloodPressureMonitor:
      return true
    case AdminSiteManagementDeviceTypes.Glucometer:
      return true
    case AdminSiteManagementDeviceTypes.PcrMachine:
      return true
    default:
      return false
  }
}

export const AdminSiteManagementDefaultDevice = {
  type: null,
  deviceId: null,
  isSelected: false,
  deviceIndex: null,
  quantity: 1,
  units: null,
}

export const enum AdminSiteManagementComponents {
  SelectSite = 'AdminSiteManagementSelectSite',
  SelectDevices = 'AdminSiteManagementAddDevices',
  AddSerialNumbers = 'AdminSiteManagementAddDeviceSerialNumbers',
  Review = 'AdminSiteManagementReview',
  Done = 'AdminSiteManagementDone',
}

export const AdminSiteManagementWizardStages = [
  {
    title: 'Select Site',
    component: AdminSiteManagementComponents.SelectSite,
    nextButtonText: 'Next',
    nextButtonAction: AdminSiteManagementWizardNextButtonActionNames.NextWizardStage,
  },
  {
    title: 'Add Devices',
    component: AdminSiteManagementComponents.SelectDevices,
    nextButtonText: 'Next',
    nextButtonAction: AdminSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: AdminSiteManagementWizardBackButtonActionNames.PreviousWizardStage,
  },
  {
    title: 'Add Serial Number',
    component: AdminSiteManagementComponents.AddSerialNumbers,
    nextButtonText: 'Next',
    nextButtonAction: AdminSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: AdminSiteManagementWizardBackButtonActionNames.PreviousSelectedDevice,
  },
  {
    title: 'Review & Confirm',
    component: AdminSiteManagementComponents.Review,
    nextButtonText: 'Confirm',
    uploadDevicesOnNextClick: true,
    nextButtonAction: AdminSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: AdminSiteManagementWizardBackButtonActionNames.PreviousWizardStage,
  },
  {
    title: 'Done',
    component: AdminSiteManagementComponents.Done,
    nextButtonText: 'Done',
    nextButtonAction: AdminSiteManagementWizardNextButtonActionNames.NextWizardStage,
    backButtonAction: AdminSiteManagementWizardBackButtonActionNames.PreviousWizardStage,
  },
]

export const AdminSiteManagementBlankSite = {
  id: '',
  siteName: '',
  org: '',
  patientMonitoringEnabled: DEFAULT_PATIENT_MONITORING_ENABLED,
  myPatientsEnabled: DEFAULT_MY_PATIENTS_ENABLED,
  kcPatientResourceType: '',
  pccOrg: '',
  pccFacId: '',
  residexClientId: '',
  residexCampusId: '',
  pids: [],
  devicesToAssign: [],
  availableVibes: 0,
  syncPatientsFromEmr: DEFAULT_SYNC_PATIENTS,
  syncAllPatientsFromEmr: DEFAULT_SYNC_ALL_PATIENTS,
  syncMinimalPatientAttributes: DEFAULT_SYNC_MINIMAL_DATA,
  syncCaregiversFromEmr: DEFAULT_SYNC_CAREGIVERS,
  sharedDevicesMatchRoomNumber: DEFAULT_MATCH_ROOM_NUMBER,
  sharedDevicesMatchResidentNumber: DEFAULT_MATCH_RESIDENT_NUMBER,
  units: [],
  emrPatients: [],
}
